<template>
  <div>
    <!-- 使用 Vant 的 van-popup 组件 -->
    <van-popup
      v-model="visible"
      :position="position"
      :overlay="overlay"
      :close-on-click-overlay="overlayClick"
      :style="{ width: '85%' }"
      class="custom-popup"
      style="background: transparent"
    >
      <div class="c-content" style="padding: 10px 0">
        <p class="f-t-18 f-w t-c">
          {{ $lang.common_txt272 }}
        </p>
        <div style="min-height: 180px">
          <div
            class="d-flex-s"
            style="flex-flow: wrap row; width: 85%; margin: 15px auto 0"
          >
            <div
              v-for="(item, index) in CountryList"
              :key="index"
              class="piker_mian_list d-flex m-b-5"
              :class="{ 'active-coun': selectIndex === index }"
              style="width: 48.5%; padding: 0 10px"
              @click="selectFun(index, item)"
            >
              <img :src="item.iconUrl" width="41" />
              <span class="m-l-5">{{ item.countryName }}</span>
            </div>
          </div>
        </div>
        <div class="d-flex" style="width: 85%; margin: 0 auto">
          <img src="../assets/img/otgame/xzgj_3.png" width="14" />
          <span class="m-l-5" style="font-size: 13px">{{ $lang.common_txt273 }}</span>
        </div>
        <div style="text-align: center; margin-top: 20px">
          <van-button
            size="large"
            class="custom-button"
            @click="confirm"
            :disabled="selectIndex === null"
            style="width: 60%; height: 35px; border-radius: 20px"
          >
            {{ $lang.Confirmar }}
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { GetPlatformList } from '@/api/common'
import { logoutIfReloginRequiredWithToken } from '@/utils/platformAuth'
export default {
  name: 'CommonLang',
  props: {
    overlayClick: {
      type: Boolean,
      default: false
    },
    // 控制弹窗显示的布尔值
    value: {
      type: Boolean,
      default: false
    },
    // 弹窗位置（top、bottom、left、right、center）
    position: {
      type: String,
      default: 'center'
    },
    // 是否显示遮罩层
    overlay: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      info: {},
      selectIndex: null,
      CountryList: [], // 初始化为空数组，等待接口返回数据
      visible: this.value, // 内部状态
      isLoading: false // 新增：请求锁，防止重复请求
    }
  },
  watch: {
    // 监听外部传入的 value 值变化
    value(newVal) {
      this.visible = newVal
      // 弹窗关闭时重置选中状态，确保下次打开按钮是禁用的
      if (!newVal) {
        this.selectIndex = null
      }
    },
    // 监听内部 visible 值变化，同步到外部 + 触发接口请求
    visible(newVal) {
      this.$emit('input', newVal)
      // 核心优化：仅当弹窗显示、列表为空、无正在进行的请求时才调用接口
      if (newVal && this.CountryList.length === 0 && !this.isLoading) {
        this.GetPlatformList()
      }
    }
  },
  mounted() {
    // 移除：不再在mounted中直接调用接口，改为通过visible监听触发
  },
  created() {},
  methods: {
    async GetPlatformList() {
      // 新增：请求锁，防止同一时间多次触发请求
      if (this.isLoading) return
      this.isLoading = true

      try {
        const data = await GetPlatformList()
        if (data.status === 'ok') {
          this.CountryList = data.content.list
        } else {
          this.$toast({
            message: data.msg,
            icon: 'cross'
          })
        }
      } catch (error) {
        this.$toast({
          message: error,
          icon: 'cross'
        })
      } finally {
        // 无论请求成功/失败，都释放请求锁
        this.isLoading = false
      }
    },
    confirm() {
      // 双重校验，确保只有选中后才执行逻辑
      if (this.selectIndex === null || this.CountryList.length === 0) {
        return
      }
      const prevPlatform = localStorage.getItem('platform')
      logoutIfReloginRequiredWithToken(prevPlatform, this.info.platform)
      localStorage.setItem('currency', this.info.currency)
      localStorage.setItem('areaCode', this.info.areaCode)
      localStorage.setItem('currencyUnit', this.info.currencyUnit)
      localStorage.setItem('platform', this.info.platform)
      localStorage.setItem('defaultLanguage', this.info.defaultLanguage)
      localStorage.setItem('iconUrl', this.info.iconUrl)
      localStorage.setItem('countryName', this.info.countryName)
      localStorage.setItem('country', this.info.country)
      if (this.$route.path.includes('/Country')) {
        this.$router.replace('/' + this.info.country + '/home')
      }
      setTimeout(() => {
        window.location.reload()
      }, 200)
    },
    selectFun(i, v) {
      this.info = v
      this.selectIndex = i
    }
  }
}
</script>

<style lang="less" scoped>
.c-content {
  background: url(../assets/img/otgame/xzgj_1.png) no-repeat;
  background-size: 100% 100%;
  min-height: 320px;
}
.piker_mian_list {
  background: url(../assets/img/otgame/xzgj_4.png) no-repeat;
  background-size: 100% 100%;
  height: 48px;
}
.active-coun {
  background: url(../assets/img/otgame/xzgj_4_s.png) no-repeat !important;
  background-size: 100% 100% !important;
  height: 48px !important;
}

/* 自定义按钮禁用状态样式，让置灰效果更明显 */
.custom-button {
  background: linear-gradient(to bottom, #bb6227, #d88332, #eea640);
  &.van-button--disabled {
    background: linear-gradient(to bottom, #777777, #898989, #898989);
    cursor: not-allowed;
  }
}
</style>
